import { COUNTRIES_NAMES as EXTERNAL_COUNTRIES_NAMES } from './countries';
export * from './currency';
export * from './countries';
export const COUNTRIES_NAMES: Record<string, string> = EXTERNAL_COUNTRIES_NAMES;
